import * as React from 'react';
import { Station } from '../../resource/'; 


import { Button } from '@independent-software/typeui/controls/Button';
import { Flex } from '@independent-software/typeui/controls/Flex';
import { Header } from '@independent-software/typeui/controls/Header';
import { Label } from '@independent-software/typeui/controls/Label';
import { Latitude, Longitude } from '@independent-software/typeui/formatters/GIS';
import { Number } from '@independent-software/typeui/formatters/Number';
import { Output } from '../../controls/Output';

class MapStationsPopup extends React.Component<{station: Station, onClick: (item:any) => void}> {
  render() {
    let p = this.props;
    return (
      <>
        <Header size="h3">Station {p.station.name}</Header>
        <div>{p.station.description}</div>
        <Label><Number value={p.station.samples_count} decimals={0}/> samples</Label>
        <div style={{height:"4px"}}/>
        <Flex.Columns count={2}>
          <Output nobackground label="Latitude"><Label><Number value={p.station.latitude} decimals={6}/></Label> <Label><Latitude value={p.station.latitude}/></Label></Output>
          <Output nobackground label="Longitude"><Label><Number value={p.station.longitude} decimals={6}/></Label> <Label><Latitude value={p.station.longitude}/></Label></Output>
        </Flex.Columns>
        <div style={{textAlign: 'right', marginTop: '4px'}}>
          <Button onClick={() => p.onClick(p.station)}>View</Button>
        </div>
      </>      
    );
  }
}

export { MapStationsPopup }
